import { Outlet } from 'react-router-dom';
import { AdminSidebar, HomeIcon, UsersIcon, WalletIcon, ChartIcon, SettingsIcon } from '../navigation/AdminSidebar';
import { useAuth } from '../../contexts/AuthContext';

export function CasinoLayout(): React.ReactElement {
  const { state } = useAuth();

  const sections = [
    {
      title: 'Dashboard',
      items: [
        { label: 'Overview', to: '/casino/dashboard', icon: <HomeIcon /> },
        { label: 'Reports', to: '/casino/reports', icon: <ChartIcon /> },
      ],
    },
    {
      title: 'Management',
      items: [
        { label: 'Users', to: '/casino/users', icon: <UsersIcon /> },
        { label: 'Cash', to: '/casino/cash', icon: <WalletIcon /> },
      ],
    },
    {
      title: 'Settings',
      items: [
        { label: 'Configuration', to: '/casino/config', icon: <SettingsIcon /> },
      ],
    },
  ];

  return (
    <div className="flex h-screen bg-background">
      <AdminSidebar
        title="Casino Manager"
        sections={sections}
        user={
          state.user
            ? {
                name: state.user.display_name || state.user.username,
                role: state.user.role,
              }
            : undefined
        }
      />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
